import React, { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import useStableVh from '../../hooks/useStableVh'
import useImagePreload from '../../hooks/useImagePreload'
import { useServiceData } from '../../hooks/useServiceData'
import { useSubServiceData } from '../../hooks/useSubServiceData'
import OrderModal from '../OrderModal/OrderModal'
import './ServiceMainScreen.css'
import mainImage1 from '../../asset/main-slider/main_1.avif'
import mainImage2 from '../../asset/main-slider/main_2.avif'

// Fallback-изображения на случай пока БД не обновлена
const fallbackImages = {
  'cvetnoj-poliuritan': mainImage1,
  himchistka: mainImage2,
  polirovka: mainImage1,
  'matovyj-poliuritan': mainImage2,
}

const ServiceMainScreen = ({ isSubService = false }) => {
  useStableVh()
  const { slug, subSlug } = useParams()
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false)

  const { data: service, isLoading: serviceLoading } = useServiceData(slug)
  const { data: subService, isLoading: subServiceLoading } = useSubServiceData(
    isSubService ? slug : null,
    subSlug
  )

  const isLoading = isSubService ? subServiceLoading : serviceLoading
  const currentItem = isSubService ? subService : service
  const heroImage =
    (isSubService ? subService?.heroImage : service?.heroImage) ||
    fallbackImages[slug] ||
    mainImage1
  const isHeroImageLoaded = useImagePreload(heroImage)

  if (!isLoading && !currentItem) {
    return (
      <main style={{ padding: '140px 20px 80px', textAlign: 'center' }}>
        <h1 style={{ marginBottom: '16px' }}>
          {isSubService ? 'Подуслуга не найдена' : 'Услуга не найдена'}
        </h1>
        <Link to="/">Вернуться на главную</Link>
      </main>
    )
  }

  return (
    <main>
      <section
        className="service-hero"
        style={{ '--service-bg': `url(${heroImage})` }}
      >
        <div
          className={`service-hero__skeleton img-skeleton ${isHeroImageLoaded ? 'is-hidden' : ''}`}
          aria-hidden="true"
        />
        <div className="service-hero__inner">
          <div className="service-hero__text">
            <h1 className="service-hero__title">{currentItem?.title}</h1>
            <p className="service-hero__description">{currentItem?.description}</p>
          </div>
          <div className="service-hero__controls">
            <button
              type="button"
              className="main-cta-button service-hero__cta"
              onClick={() => setIsOrderModalOpen(true)}
            >
              <span>Заказать услугу</span>
              <ArrowRight size={20} strokeWidth={2} />
            </button>
          </div>
        </div>
      </section>

      <OrderModal
        isOpen={isOrderModalOpen}
        onClose={() => setIsOrderModalOpen(false)}
        serviceName={currentItem?.title}
      />
    </main>
  )
}

export default ServiceMainScreen
